<template>
    <div class="about-page">
        <section class="hero-section">
            <h1 class="page-title" data-aos="fade-up">About Us</h1>
        </section>

        <section class="image-carousel" data-aos="fade-up" data-aos-delay="100">
            <swiper :modules="[Autoplay]" :slides-per-view="1" :space-between="20" :loop="true"
                :autoplay="{ delay: 4000, disableOnInteraction: false }">
                <swiper-slide><img src="../assets/aboutus5.jpeg" alt="Image 10" /></swiper-slide>
                <swiper-slide><img src="../assets/aboutus6.jpeg" alt="Image 11" /></swiper-slide>
                <swiper-slide><img src="../assets/aboutus7.jpeg" alt="Image 12" /></swiper-slide>
                <swiper-slide><img src="../assets/funstopresized.jpg" alt="Image 1" /></swiper-slide>
                <swiper-slide><img src="../assets/funstop_2.jpg" alt="Image 2" /></swiper-slide>
                <swiper-slide><img src="../assets/funstop_3.jpg" alt="Image 3" /></swiper-slide>
                <swiper-slide><img src="../assets/funstop_4.jpg" alt="Image 4" /></swiper-slide>
                <swiper-slide><img src="../assets/funstop_5.jpg" alt="Image 5" /></swiper-slide>
                <swiper-slide><img src="../assets/aboutus1.jpg" alt="Image 6" /></swiper-slide>
                <swiper-slide><img src="../assets/aboutus2.jpeg" alt="Image 7" /></swiper-slide>
                <swiper-slide><img src="../assets/aboutus3.jpeg" alt="Image 8" /></swiper-slide>
                <swiper-slide><img src="../assets/aboutus4.jpeg" alt="Image 9" /></swiper-slide>
               
            </swiper>
        </section>

        <section class="description card" data-aos="fade-up" data-aos-delay="200">
            <p>
                We are a five-year-old evolving company, that operates from the tourism resort areas of Pigeon Forge,
                Tennessee. Our office is just
                outside of the city but the city is still in its heart. We offer jobs in the Hospitality, Tourism,
                Recreation, and Transportation Industry.
                We provide Winter and Summer Job opportunities for persons living outside of the USA. We are a seasonal
                business; however, we
                operate all year through. Our company offers the following:
            </p>
            <ul>
                <li>Cultural Exchange</li>
                <li>The Opportunity to Travel</li>
                <li>The opportunity to gain excellent work experience while developing skills and professionalism.</li>
            </ul>
        </section>

        <section class="mission-vision">
            <div class="statement card" data-aos="fade-up" data-aos-delay="300">
                <h2>Mission Statement</h2>
                <p>RTH Group Inc is committed to Building Nations Confidence Through Education, Training and Labour Force.</p>
            </div>

            <div class="statement card" data-aos="fade-up" data-aos-delay="400">
                <h2>Vision Statement</h2>
                <p>
                    Providing a Cultural Exchange Through Workforce Labour to Impact the Global Community Through Proffesionalism and Integrity.
                </p>
            </div>
        </section>
        <section class="partner-logos card" data-aos="fade-up" data-aos-delay="500">
            <h2>Group Of Companies</h2>
            <div class="logos-container">
                <div class="logo-item">
                    <img src="@/assets/VaDaBa%20LOGO.png" alt="VaDaBa Logo" class="partner-logo" />
                    <p class="logo-caption">VaDaBa</p>
                </div>
                <div class="logo-item">
                    <img src="@/assets/asea.png" alt="ASEA Logo" class="partner-logo" />
                    <p class="logo-caption">All Seasons Exchange Agency</p>
                </div>
                <div class="logo-item">
                    <img src="@/assets/R.T.H%20Logo%20Image.png" alt="RTH Cleaners Logo" class="partner-logo" />
                    <p class="logo-caption">RTH Cleaners</p>
                </div>
               
            </div>
        </section>
    </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules'; // ✅ Correct way for modules now
import 'swiper/css';
import 'swiper/css/autoplay'; // (keep this for autoplay styles)
import { onMounted } from 'vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

onMounted(() => {
    AOS.init({
        duration: 1000,
        once: true,
    });
})
</script>

<style scoped>
/* Container & Layout */
.about-page {
  padding: 2rem;
  box-sizing: border-box;
  max-width: 1000px;
  margin: 0 auto;
  overflow-x: hidden;
}

.hero-section {
  text-align: center;
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* Title */
.page-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #3a0ca3;
}

/* Image Carousel */
.image-carousel {
  max-width: 1000px;
  margin: 0 auto 2rem;
}

.image-carousel img {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

/* Card Base Styles */
.card {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  width: 100%;
  box-sizing: border-box;
}

/* Description Section */
.description {
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
}

.description p,
.description ul {
  word-break: break-word;
}

.description ul {
  padding-left: 1.25rem;
  list-style: disc;
  margin-top: 1rem;
}

/* Mission & Vision */
.mission-vision {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.statement {
  text-align: center;
}

.statement h2 {
  font-size: 1.75rem;
  color: #3a0ca3;
  margin-bottom: 0.5rem;
}

.statement p {
  font-size: 1rem;
  color: #444;
  max-width: 700px;
  margin: 0 auto;
}

/* Logos Section */
.partner-logos {
  text-align: center;
}

.partner-logos h2 {
  font-size: 1.75rem;
  color: #3a0ca3;
  margin-bottom: 1.5rem;
}

.logos-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.logo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 120px;
}

.partner-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 0.5rem;
}

.logo-caption {
  font-size: 0.875rem;
  color: #333;
  text-align: center;
  line-height: 1.2;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .about-page {
    padding: 1rem;
    max-width: 100%;
  }

  .hero-section {
    margin-bottom: 1.5rem;
  }

  .page-title {
    font-size: 1.75rem;
  }

  .partner-logos h2 {
    font-size: 1.5rem;
  }

  .statement h2 {
    font-size: 1.25rem;
  }

  .statement p,
  .description {
    font-size: 0.95rem;
    padding: 1rem;
  }

  .card {
    padding: 1rem;
  }

  .mission-vision {
    gap: 1.25rem;
  }

  .logos-container {
    gap: 1.5rem;
  }

  .logo-item {
    max-width: 100px;
  }

  .partner-logo {
    width: 60px;
    height: 60px;
  }

  .logo-caption {
    font-size: 0.75rem;
  }
}
</style>
